import React, { PureComponent } from "react";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { TextGeometry } from "three/addons/geometries/TextGeometry.js";
import { FontLoader } from "three/addons/loaders/FontLoader.js";
import { CSG } from "three-csg-ts";
import {Generatebase,GenerateRiser, GenerateCone,GenerateLed}from "./DrawingsGen";

import {
  CSS2DRenderer,
  CSS2DObject
} from "three/examples/jsm/renderers/CSS2DRenderer.js";

const ManVis = ({ elements ,Diameter=1050, Thickness=200 ,RiserHeight=450,RiserThickness=100}) => {
  const RF2 = 3/Diameter;
  const canvasRef = React.useRef(null);



  React.useEffect(() => {
    if (canvasRef.current && canvasRef.current.children.length === 0) {
      // Initialize the scene, camera, and renderer
      const scene = new THREE.Scene();

      const camera = new THREE.PerspectiveCamera(
        75,
        window.innerWidth / window.innerHeight,
        0.1,
        1000
      );
      camera.position.set(0, 1, 12);
      scene.position.set(-5, 0, 0);
      const renderer = new THREE.WebGLRenderer({ antialias: true });
      renderer.setSize(1000, 560);
      renderer.setClearColor(0xffffff, 1.0);

      // Append the renderer DOM element to the canvasRef
      canvasRef.current.appendChild(renderer.domElement);

      // Add axes helper to the scene

     const Base = Generatebase(RF2,Diameter,scene,Thickness);

      scene.add(Base);
     const Riser = GenerateRiser(RF2,Diameter,RiserHeight,RiserThickness,Base);
      scene.add(Riser);



      let Cone = GenerateCone(RF2,Diameter,RiserHeight,RiserThickness,scene);
      scene.add(Cone);

     let Led = GenerateLed(RF2,Diameter,scene);
      scene.add(Led);


      const color = 0xffffff;
      const intensity = 10;
      const light = new THREE.DirectionalLight(color, intensity);
      light.position.set(0, 10, 0);
      light.target.position.set(-5, 0, 0);
      scene.add(light);
      scene.add(light.target);
      //scene.add(new THREE.AmbientLight(0x404040));
      // Add a directional light to the scene
      const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
      directionalLight.position.set(0, 1, 0);
      scene.add(directionalLight);
      // Set up orbit controls
      const orbit = new OrbitControls(camera, renderer.domElement);

      orbit.update();

      // Animation loop
      const animate = () => {
        requestAnimationFrame(animate);
        // orbit.update(); // Update the controls in the animation loop
        renderer.render(scene, camera);
      };
      animate();

      // Handle window resize
      const handleResize = () => {
        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(window.innerWidth, window.innerHeight);
      };
      window.addEventListener("resize", handleResize);

      // Clean up on component unmount
      return () => {
        window.removeEventListener("resize", handleResize);
        if (canvasRef.current) {
          canvasRef.current.removeChild(renderer.domElement);
        }
      };
    }
  }, []);
  const resizeFactor = 1000 / 1200;
  const [remainingWidth, setRemainingWidth] = React.useState(1200);
  React.useEffect(() => {
    if (elements && remainingWidth == 1200) {
      for (let i of elements) {
        setRemainingWidth((prev) => prev - i[4] / 100);
      }
    }
  }, []);
  return (
    <>
      <div className="card-body">
        <h2>Manhole Visualization</h2>

        <div ref={canvasRef}></div>
      </div>
    </>
  );
};

export default ManVis;
